import React from "react";
import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { AudienceModalContext } from "../../pages/campaigns/Campaigns";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4
};

export default function CreateAudienceModal() {
  const { open, setOpen, setSelected } = React.useContext(AudienceModalContext);
  const [audience, setAudience] = React.useState("");
  const handleClose = () => setOpen(false);
  const handleSubmit = () => {
    setAudience("");
    setSelected([]);
    handleClose();
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Create Audience
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            value={audience}
            onChange={(e) => setAudience(e.target.value)}
            required
            fullWidth
            label="Audience Name"
          />
          <Button sx={{ mt: 4 }} type="submit" variant="contained">
            Submit
          </Button>
        </form>
      </Box>
    </Modal>
  );
}
